import { Link } from 'react-router-dom';
import { classicDealHref, NO_DEAL_WORDS } from '@/lib/v3-classic.js';

// "OPEN DEAL" on every term block and every pending term: the classic deal
// workspace for the term's CRM deal, where the quote entry and the rater live
// (lib/v3-classic.js classicDealHref, the one place that builds the URL).
// Where there is no deal to open the words say why; never a link that opens nothing.
export default function OpenDeal({ account, crmDealId, className = '' }) {
  const c = classicDealHref(account, crmDealId);
  if (!c.href) return <span className={`text-xs text-text-dim ${className}`} data-open-deal data-open-deal-reason={c.reason}>{NO_DEAL_WORDS[c.reason]}</span>;
  return (
    <Link to={c.href} className={`inline-flex min-h-[36px] items-center text-sm font-medium text-accent underline-offset-2 hover:underline ${className}`} data-open-deal data-open-deal-href={c.href}>
      Open deal
    </Link>
  );
}
